// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_b71e2ddf"};